export default __webpack_public_path__ + "static/media/messageWarning16.80d35075.svg";